module.exports = __webpack_public_path__ + "static/media/dk.33bba71c.svg";